import React from 'react';
const NotFound = props => {
    return (<div >
        <span>Not found</span>
    </div>)
}
export default NotFound;